import axios from "axios";

export function createAccounts(data) {
  let configAccount = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts`,
    data: data
  };

  return axios(configAccount);
}

export function createBusinesses(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${data.accountId}/businesses`,
    data: data
  };
  return axios(config);
}

export function createRichmenu(accountId ,data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(config);
}

export function createDefaultItem(accountId) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/default-item`,
    data: {}
  };
  return axios(config);
}

export function createContract(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/contract`,
    data: data
  };
  return axios(config);
}

export function enable(accountId) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/sys/enabled`,
    data: {
      accountId
    }
  };
  return axios(config);
}

export function disable(accountId) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/sys/disabled`,
    data: {
      accountId
    }
  };
  return axios(config);
}

export function createPromotion(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.businessId}/promotions`,
    data: data
  };
  return axios(config);
}

export function promotionSetting(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.businessId}/promotions/${data.id}/setting`,
    data: {data}
  };
  return axios(config);
}

export function updateInitializedStatus(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.id}/initail-status`,
    data: {data}
  };
  return axios(config);
}

export function removeOld(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.accountId}/oa-disabled`
  };
  return axios(config);
}

export function addShopTag(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/tags/shops/${data.shopId}`,
    data: {
      tagName: data.tagName
    }
  };
  return axios(config);
}

export function createPrinter(accountId, shop, data) {
  let config = {
      method: 'POST',
      url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/printers`,
      params: shop,
      data
  }
  return axios(config);
}

export function invoiceSwitch(accountId, data) {
  let config = {
      method: 'POST',
      url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/invoice-switch`,
      data
  }
  return axios(config);
}

export function createInvoice(accountId, data) {
  let config = {
      method: 'POST',
      url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/invoice`,
      data
  }
  return axios(config);
}

export function fetchInvoices(accountId, data) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/fetch-invoices`,
    data
  }
  return axios(config);
}

export function createPosmw(accountId, data) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/mw-settings`,
    data
  }
  return axios(config);
}

export function enableService(accountId, service, data) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/services/${service}`,
    data
  }
  return axios(config);
}

export function addActiveVendor(accountId, vendor_code) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/mw-setting-active`,
    data: { vendor_code }
  }
  return axios(config);
}

export function postFoodpandaMenu(shopId, foodpandaId, menuJson) {
  let config = {
    method: "POST",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${shopId}/foodpanda-menu`,
    data: { foodpanda_id: foodpandaId, menu_json: menuJson},
  };
  return axios(config);
}
